import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardListComponent } from './dashboard-list/dashboard-list.component';
import { DashboardForItComponent } from './dashboard-for-it/dashboard-for-it.component';
import {CalendarModule} from 'primeng/primeng';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {TranslateModule} from '@ngx-translate/core';
import { DashboardDocumentComponent } from './dashboard-document/dashboard-document.component';
import { DashboardStorageComponent } from './dashboard-storage/dashboard-storage.component';

@NgModule({
  imports: [
    CommonModule,
    DashboardRoutingModule,
    DropdownModule,
    FormsModule,
    CalendarModule,
    NgbDropdownModule,
    TranslateModule
  ],
  declarations: [
    DashboardListComponent,
    DashboardForItComponent,
    DashboardDocumentComponent,
    DashboardStorageComponent
  ]
})
export class DashboardModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/dashboard/dashboard.module.ts